import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { isDebugUIEnabled } from '../../config/debug';
import { useDebugPhase } from '../../context/DebugPhaseContext';
import useWSTurnState, { TURN_PHASES } from '../../hooks/useWSTurnState';
import ModeratorBox from '../ModeratorBox/ModeratorBox';
import BackgroundColor from '../Slides/BackgroundColor';
import ContentCheckout from '../Slides/ContentCheckout';
import ContentFraseCompletar from '../Slides/ContentFraseCompletar';
import ContentGoodbye from '../Slides/ContentGoodbye';
import ContentWaitingPartner from '../Slides/ContentWaitingPartner';
import DebugGrid from '../Slides/Elements/DebugGrid';
import FeedbackBalloon from '../Slides/FeedbackBalloon';
import '../Slides/SlidesCommon.css';
import StateDisplay from '../Slides/StateDisplay';
import WelcomeSlideContent from '../Slides/WelcomeSlideContent';
import SuggestionsPanel from '../SuggestionsPanel/SuggestionsPanel';

// const isMobile = () => {
//   const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//   const isMobileWidth = window.innerWidth <= 768;
//   return isMobileUA || isMobileWidth;
// };

export default function SlideContent() {
  const debug = isDebugUIEnabled;
  const realTurnState = useWSTurnState(debug);
  const { debugPhase, setDebugPhase } = useDebugPhase();
  const [showDebugGrid, setShowDebugGrid] = useState(false);

  const currentPhase = debug ? debugPhase : realTurnState.currentPhase;

  const handlePhaseChange = (newPhase) => {
    setDebugPhase(newPhase);
  };

  const toggleDebugGrid = () => {
    setShowDebugGrid(prev => !prev);
  };

  const isWaitingFlow = currentPhase === TURN_PHASES.WaitingPartner;

  const isWelcomeFlow = currentPhase === TURN_PHASES.Welcome ||
                        currentPhase === TURN_PHASES.GroundRules ||
                        currentPhase === TURN_PHASES.SelfIntroductions ||
                        currentPhase === TURN_PHASES.SelfIntroductionsA ||
                        currentPhase === TURN_PHASES.SelfIntroductionsAtoB ||
                        currentPhase === TURN_PHASES.SelfIntroductionsB ||
                        currentPhase === TURN_PHASES.SelfIntroductionsDone ||
                        currentPhase === TURN_PHASES.TodayTheme;

  const isCompletingFlow = currentPhase === TURN_PHASES.ACompleting ||
                           currentPhase === TURN_PHASES.BCompleting ||
                           currentPhase === TURN_PHASES.AQuestion ||
                           currentPhase === TURN_PHASES.BQuestion ||
                           currentPhase === TURN_PHASES.FreeChat ||
                           currentPhase === TURN_PHASES.Transitioning;

  const isGoodbyeFlow = currentPhase === TURN_PHASES.Goodbye;
  const isCheckoutFlow = currentPhase === TURN_PHASES.Checkout;

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
      <DebugGrid show={showDebugGrid} />
      {debug && <StateDisplay onPhaseChange={handlePhaseChange} onToggleGrid={toggleDebugGrid} showDebugGrid={showDebugGrid} />}
      <BackgroundColor />
      <AnimatePresence mode="wait">
        <SuggestionsPanel currentPhase={currentPhase}/>
      </AnimatePresence>
      <FeedbackBalloon currentPhase={currentPhase} debugMode={debug} />
      <ModeratorBox />
      {isWaitingFlow && <ContentWaitingPartner />}
      {isWelcomeFlow && <WelcomeSlideContent currentPhase={currentPhase} />}
      {isCompletingFlow && <ContentFraseCompletar />}
      <AnimatePresence mode="wait">
        {isGoodbyeFlow && <ContentGoodbye key="goodbye" />}
        {isCheckoutFlow && <ContentCheckout key="checkout" />}
      </AnimatePresence>
    </div>
  );
}
